module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_common_none.91f146df.gif";